import type { PublicBidEntry } from '@neon-one/auctions-types';

// GT1-469 moved WS bid fan-out off the HTTP request path onto SQS + a worker,
// so a `bid.placed` frame can now arrive AFTER the client re-fetched bid
// history that already contains that bid. Prepending unconditionally rendered
// the bid twice and pushed a genuine entry out of the 10-row cap.
//
// `bidId` is the only identifier shared by both sources: the frame carries
// payload.bidId and the detail endpoint now returns it on each entry.
// placedAt is not usable — the frame stamps dispatch-build time while the
// fetched entry carries the DB row's timestamp — and amount + handle can
// legitimately repeat (equal-cap max tie-break, colliding anonymized handles).
//
// Returns false when `bidId` is absent on either side (older payloads or
// mock/demo entries): callers then keep the historical prepend behaviour
// rather than guessing with a fuzzy key.
export function historyHasBid(
  history: readonly PublicBidEntry[],
  bidId: number | null | undefined,
): boolean {
  if (bidId == null) return false;
  return history.some((entry) => entry.bidId === bidId);
}
